<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="types"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a type ID by choosing its name
     *
     */
    export default {
        name: 'ies-icaltypekey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                types: [{text: "Availability", value:1}, {text: "Closures", value:2}],
                viewValue: parseInt(this.field.value),
            }
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
